import { render, staticRenderFns } from "./IPR.vue?vue&type=template&id=572ff0cc&"
import script from "./IPR.vue?vue&type=script&lang=js&"
export * from "./IPR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports